import { useContext } from "react";
import { ThemeContext } from "./context/themeContext";
import { ConfigProvider } from "antd";


const ThemeConfig = ({ children }) => {
    const { theme } = useContext(ThemeContext)

    return (
        <ConfigProvider
            theme={{
                token: {
                    fontFamily: 'poppinsregular',
                    colorPrimary: theme === "primary" ? "#FE5F7B" : "#ee8533",
                    colorPrimaryHover: theme === "primary" ? "#7e57ff" : "#0A6BCD",
                    colorPrimaryBgHover: theme === "primary" ? "#7e57ff" : "#0A6BCD",
                    colorLink: theme === "primary" ? "#9747ff" : "#0d599b",
                },
                components: {
                    Steps: {
                        dotSize: 30,
                        dotCurrentSize: 30,
                        colorPrimary: theme === "primary" ? "black" : "red",
                        // colorSplit: "#D9D9D9",
                        iconFontSize: 0,
                    },
                    Layout: {
                        footerPadding: 32,
                        headerHeight: 100,
                        headerBg: theme === "primary" ? "#FE5F7B" : "#0d599b"
                    },
                    Button: {
                        fontWeight: 500,
                        fontSizeLG: "1rem",
                        colorPrimaryHover: theme === "primary" ? "#9747ff" : "#0A6BCD",
                        colorPrimaryBgHover: theme === "primary" ? "#9747ff" : "#0A6BCD",
                        colorPrimaryActive: theme === "primary" ? "#9747ff" : "#0A6BCD",
                    },
                    Input: {
                        colorBgContainer: "#F7F7F7",
                        controlHeight: 36,
                        colorBorder: "#ccc",
                        hoverBg: "#ffffff",
                        activeBg: "#ffffff",
                    },
                    Radio: {
                        fontSize: "0.813rem",
                        fontFamily: 'poppinsmedium',
                    },
                    Select: {
                        optionSelectedBg: theme === "primary" ? "#FE5F7B" : "#0d599b",
                        optionSelectedColor: "#fff",
                        controlHeightLG: 40,
                        fontSizeLG: "0.813rem",
                        optionFontSize: "0.813rem",
                        optionSelectedFontWeight: 500,
                        colorBorder: "#000000",
                        colorPrimaryBorderHover: "green",
                        colorTextPlaceholder: "#000000",
                        fontWeightStrong: 700,
                    },
                    Form: {
                        itemMarginBottom: 12,
                        colorError: "red",
                        fontSize: "0.813rem",
                        labelFontSize: "0.813rem"
                    },
                    DatePicker: {
                        controlHeight: 36,
                        colorBgContainer: "#F7F7F7",
                        hoverBg: "#ffffff",
                        activeBg: "#ffffff",
                        fontSize: "0.813rem"
                    },
                    Tree: {
                        colorBorder: "#000000",
                        fontSize: "0.813rem",
                        fontFamily: 'poppinsmedium',
                    },
                    Card: {
                        boxShadowTertiary: false,
                    },
                    Checkbox: {
                        fontSize: "0.938rem",
                        colorPrimaryHover: theme === "primary" ? "#9747ff" : "#0A6BCD",
                    }
                },
            }}
        >
            {children}
        </ConfigProvider>
    )
}

export default ThemeConfig